import {generateArray} from "../../../utils/array-helper"
import {AmbientModeLightLineBox} from "./boxes/ambient-mode-lights/ambient-mode-light-line.box"
import {AmbientModeLightsBox} from "./boxes/ambient-mode-lights/ambient-mode-lights.box"

export const WheelAmbientModeLights: React.FC = () =>  {
    return <AmbientModeLightsBox className="lights-around-wheel">
        {generateArray(8).map((idx) => (
            <AmbientModeLightLineBox className="light-line" key={idx} lineIndex={idx} />
        ))}
    </AmbientModeLightsBox>
}